import { render, staticRenderFns } from "./SaleEditSaveModal.vue?vue&type=template&id=4c49f4fc&scoped=true"
import script from "./SaleEditSaveModal.vue?vue&type=script&lang=ts"
export * from "./SaleEditSaveModal.vue?vue&type=script&lang=ts"
import style0 from "./SaleEditSaveModal.vue?vue&type=style&index=0&id=4c49f4fc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c49f4fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c49f4fc')) {
      api.createRecord('4c49f4fc', component.options)
    } else {
      api.reload('4c49f4fc', component.options)
    }
    module.hot.accept("./SaleEditSaveModal.vue?vue&type=template&id=4c49f4fc&scoped=true", function () {
      api.rerender('4c49f4fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleEditSaveModal.vue"
export default component.exports